import axios from 'axios';
import store from '../../store/store';
import * as msal from "@azure/msal-browser";
import LRUCache from "lru-cache";
import {axiosBaseURL} from "../../config/config";
import {cacheAdapterEnhancer} from "axios-extensions";

// Setup Basic Axios instance Interceptor
axios.interceptors.request.use(
    // console.log('in authservice')
    async (config) => {
        // console.log(config);
        config.headers['x-api-challenge'] = localStorage.getItem('challenge') || 'no-key-found';

        // console.log(config.url);

        // refreshAccessToken method is the one which makes acquireTokenSilent call
        const token = await refreshAccessToken(config.url);
        if (token) {
            config.headers['Authorization'] = `Bearer ${token.accessToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);


// AxiosCache Instance
const ONE_HOUR = 1000 * 60 * 60 // 1 hr
const defaultCache = new LRUCache({ maxAge: ONE_HOUR, clearOnStale: true })

// NOTE: This instance is using caching specifically for images etc.
export const axiosCached = axios.create({
    baseURL: axiosBaseURL(),
    headers: { 'Cache-Control': 'no-cache' },
    // disable the default cache and set the cache flag
    adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false, cacheFlag: 'useCache', defaultCache })
});

// Setup Axios Cache instance Interceptor
axiosCached.interceptors.request.use(
    // console.log('in authservice')
    async (config) => {
        // console.log(config);
        config.headers['x-api-challenge'] = localStorage.getItem('challenge') || 'no-key-found';

        // console.log(config.url);

        // refreshAccessToken method is the one which makes acquireTokenSilent call
        const token = await refreshAccessToken(config.url);
        if (token) {
            config.headers['Authorization'] = `Bearer ${token.accessToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);


const refreshAccessToken = async(url) => {
    const state = store.getState();
    const auth = state.auth;
    const config = state.config;

    // MSAL-Browser - Token Renewal
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/token-lifetimes.md#token-renewal
    // determine which api the axios call is for
    // console.log(url);
    let tokenRequest = {};
    if (url.indexOf('loader') > 0) {
        tokenRequest = {
            scopes: config.data.dataLoader.scopes
        };
    } else if (url.indexOf('graph') > 0 ) {
        tokenRequest = {
            scopes: config.data.avatar.scopes
        };
    } else {
        tokenRequest = {
            scopes: config.data.authentication.scopes
        };
    }

	tokenRequest.authority = config.data.authentication.authority;
    tokenRequest.account = auth.clientApplication.getAccountByUsername(auth.email);
    return auth.clientApplication.acquireTokenSilent(tokenRequest).catch(error => {
        console.warn("silent token acquisition fails. acquiring token using redirect");
        if (error instanceof msal.InteractionRequiredAuthError) {
            // fallback to interaction when silent call fails
            // console.log('blah');
            return auth.clientApplication.acquireTokenRedirect(tokenRequest);
        } else {
            console.warn(error);
        }
    })
}